var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon 11",
    d: "M17.3373 8.61685C18.0452 8.99285 18.0452 10.0072 17.3373 10.3831L1.71909 18.679C1.05304 19.0327 0.25 18.55 0.25 17.7958L0.25 1.20418C0.25 0.450007 1.05305 -0.0327448 1.7191 0.321035L17.3373 8.61685Z",
    fill: "#FFD88D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowArrow);
export default __webpack_public_path__ + "static/media/yellow_arrow.ff29e255d245df9180679a4283b7c68e.svg";
export { ForwardRef as ReactComponent };